/* Editable card labels and native quantity prices. Shopify calculates discounts. */
(() => {
  'use strict';
  function cents(value) {
    const match = String(value ?? '').trim().match(/^(\d+)(?:\.(\d{1,2}))?$/);
    if (!match) return null;
    const amount = Number(match[1]) * 100 + Number((match[2] || '').padEnd(2, '0'));
    return Number.isSafeInteger(amount) ? amount : null;
  }

  function quote({ price, compare = 0, quantity, breaks = [], displayTotal = '', allowDisplayPrice = false, subscription = false }) {
    if (!Number.isSafeInteger(quantity) || quantity < 1 || !Number.isSafeInteger(price) || price < 0) return null;
    let unitPrice = price, threshold = 0;
    // Shopify supplies contextual quantity pricing in the shopper's currency.
    if (!subscription) {
      for (const item of breaks) {
        if (Number.isSafeInteger(item.minimum_quantity) && item.minimum_quantity > threshold && item.minimum_quantity <= quantity && Number.isSafeInteger(item.price) && item.price >= 0) {
          unitPrice = item.price;
          threshold = item.minimum_quantity;
        }
      }
    }
    const subtotal = unitPrice * quantity;
    if (!Number.isSafeInteger(subtotal)) return null;
    const labelPrice = cents(displayTotal);
    const usesDisplayPrice = allowDisplayPrice && !subscription && breaks.length === 0 && labelPrice !== null;
    return {
      total: usesDisplayPrice ? labelPrice : subtotal,
      compareTotal: Math.max(Number(compare) || 0, price) * quantity,
      usesDisplayPrice
    };
  }

  window.HomiHavenBundlePricing = { cents, quote };
  document.dispatchEvent(new CustomEvent('product:bundle-pricing-ready'));
})();
